module.exports = __webpack_public_path__ + "0345b7ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/hero_iphone_en@2x.png
// module id = 1041
// module chunks = 0